const ManualGettingStarted = () => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.17788 3.33789C4.45072 3.77181 4 4.56129 4 5.41105V27.589C4 28.4387 4.45072 29.2282 5.17788 29.6621C5.90505 30.096 6.8125 30.1141 7.55769 29.7043L27.75 18.6153C28.5192 18.1935 29 17.3799 29 16.5C29 15.6201 28.5192 14.8065 27.75 14.3847L7.55769 3.29571C6.8125 2.8859 5.91106 2.90398 5.17788 3.33789ZM6.88462 26.7754V6.22464L25.5925 16.5L6.88462 26.7754Z" fill="black" />
    </svg>
)
export default ManualGettingStarted;
